import { render, staticRenderFns } from "./PdfFootnote.vue?vue&type=template&id=86af425a"
import script from "./PdfFootnote.vue?vue&type=script&lang=js"
export * from "./PdfFootnote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports